<template>
  <div id='design-portfolio-summary'>
    <div class='is-flex is-align-items-center'>
      <!-- Time Selector Component -->
      <RadioButtonSelect
        :options='timeOptions'
        :default='selectedTime'
        @input='updateTime'/>

        <b-tooltip
          :class="{ 'is-invisible': minIncluded == 100 }"
          :label="`Calculations based on the ${minIncluded}% of the funds in your starting portfolio that have a track record during the selected time period. Funds that were not in existence during the selected time period are removed from the calculation, and the remaining holdings are re-weighted to maintain consistent proportions.`"
          position='is-right'
          multilined>

          <i class='fa fa-info-circle mx-2'></i>
        </b-tooltip>
    </div>


    <b-table
      :data='tableData'
      :row-class="r => r.better && ' highlighted'">

      <b-table-column
        v-slot='props'>
        <span>{{ props.row.metric }}</span>
      </b-table-column>

      <b-table-column
        v-for='col in columns'
        :key='col.field'
        :label="col.label !== undefined && portfolio ? portfolio + col.label : ''"
        :field='col.field'
        v-slot='props'>

        {{ format(props, col) }}
      </b-table-column>
    </b-table>
  </div>
</template>



<script>
  import RadioButtonSelect from './RadioButtonSelect.vue'

  export default {
      name: 'component-name',
      components: { RadioButtonSelect },
      props: ['results', 'metrics', 'targets'],
      data() { return {
        columns: [
          { field: 'prev', numeric: true, round: 2, label: '' },
          { field: 'new',  numeric: true, round: 2, label: ' With Alternatives' }
        ],
        timeOptions: [
          { value: '1y'  },
          { value: '3y'  },
          { value: '5y'  },
          { value: '10y' }
        ],
        selectedTime: '5y'
      }},
      beforeCreate() {},
      created() {},
      mounted() {},
      updated() {},
      computed: {
        portfolio() {
          try { return this.targets.portfolio.name }
          catch(e) { return '' }
        },
        keys() {
          const all = Object.keys(this.results)

          return {
            prev: all.filter(name => name.startsWith('base_portfolio_weighted')),
            new:  all.filter(name => name.startsWith('new_base_portfolio_weighted'))
          }
        },
        tableData() {
          const results = this.results

          return this.metrics.map(m => {
            const isTimeMetric = m.key[m.key.length - 1] === '_'
            const key = m.key + (isTimeMetric ? this.selectedTime : '')

            const values = {
              prev: results['base_portfolio_weighted_'     + key],
              new:  results['new_base_portfolio_weighted_' + key],
            }

            return {
              metric:   m.name,
              pct:      m.pct,
              x:        m.times,
              prev:     values.prev,
              new:      values.new,
              better:   this.isBetter(m, values),
              included: this.getIncludedPct(results.funds_included, key),
            }
          })
        },
        minIncluded() {
          const included = this.tableData.map(row => row.included);
          return Math.min(...included);
        },
      },
      watch: { /*
          Watches an existing property
          Only runs when the watched property changes */
      },
      methods: {
        format(props, col) {
          const raw = props.row[col.field]
          if(!raw) return ''

          const text  = this.getDisplayValue(props, col, raw)
          const pct   = props.row.pct && col.field !== 'metric'
          return col.pct || pct ? text + '%' : text
        },
        getDisplayValue(props, col, raw) {
          if(typeof(raw) !== 'number') return raw

          const scaled = props.row.x ? raw *= props.row.x : raw
          return col.round ? scaled.toFixed(col.round) : scaled
        },
        isBetter(metric, values) {
          if(values.prev === values.new) return false
          const isLower  = values.new < values.prev
          const isHigher = !isLower
          return metric.lowerIsBetter ? isLower : isHigher
        },
        getIncludedPct(results, key) {
          const min = Math.min(
            results['base_portfolio_weighted_'     + key],
            results['new_base_portfolio_weighted_' + key],
          );
          return parseInt(min * 100);
        },
        updateTime(time) {
          this.selectedTime = time
        }
      }
  }
</script>



<style>
  #design-portfolio-summary .b-table {
    font-size: 1.5rem;
  }

  #design-portfolio-summary tr.highlighted td:last-child {
    font-weight: bold;
    color: #48c78e
  }
</style>